import axios from "axios";
import { lazy, type SyncLazy } from "lazy-var";

export function createCurrencyFormatter(
    locale: string,
    currency: string,
    minimumFractionDigits = 0,
    maximumFractionDigits = 0
) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    });
}

const lazyFormatter = lazy(() => {
    return createCurrencyFormatter(
        window.odendo.globals.locale,
        window.odendo.globals.currency
    );
}) as SyncLazy<Intl.NumberFormat>;

export function formatAmount(n: number) {
    return lazyFormatter.get().format(n);
}

export async function toggleFollowProduct(productId: number) {
    const response = await axios.post<{
        Subscribed: 0 | 1;
        Success: 0 | 1;
    }>(`/auctionProduct/ToggleSubscribeProduct/${productId}`);
    if (response.data.Success !== 1) {
        throw new Error("Failed");
    }
    return response.data.Subscribed == 1;
}
